<template>
<div class="chapter">
<div class="inner_page">
<p class="p6">Per Stephen Nowak,</p>
<p class="p0">ovunque tu sia.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?49f8524c